<template>
  <div class="heroImage">
    <div class="container">
      <h1 class="heroImageTitle">Lernpfad</h1>
      <h2 class="heroImageClaim">
        {{ $t('Lernen einfach strukturiert') }}
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style
  lang="scss"
  scoped
>
@import '../../assets/style/vars';
@import '../../assets/style/utils';

.heroImage {
  background-color: #0f0a3b;
  padding: calculateRem(150px) calculateRem(40px) calculateRem(75px);
  background-image: url(../../assets/images/start/hero.svg?inline);
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-size: auto 100%;
}

.heroImageTitle {
  color: #fff;
  @include fontSize(75px);
  font-weight: 900;
  padding-top: calculateRem(30px);
}

.heroImageClaim {
  color: #fff;
  @include fontSize(35px);
  font-weight: 500;
}

@media (max-width: map-get($grid-breakpoints, lg)) {
  .heroImage {
    padding: calculateRem(40px) calculateRem(20px);
  }

  .heroImageTitle {
    @include fontSize(45px);
  }

  .heroImage {
    background-size: 45% auto;
  }
}
</style>
